import { AppShell } from "@/components/AppShell";

/** Skeleton da ficha do disco — usado no pending da rota e no loading do detalhe. */
export function AlbumPageSkeleton() {
  return (
    <AppShell>
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-background/40 via-background/80 to-background" />
        <div className="relative mx-auto grid max-w-7xl gap-8 px-4 py-12 md:grid-cols-[auto_1fr] lg:px-8 lg:py-16">
          <div className="aspect-square w-56 animate-pulse rounded-2xl bg-surface shadow-2xl shadow-black/60 lg:w-72" />
          <div className="flex flex-col justify-end gap-3">
            <div className="h-3 w-24 animate-pulse rounded bg-surface" />
            <div className="h-10 w-3/4 animate-pulse rounded bg-surface lg:h-14" />
            <div className="h-4 w-1/2 animate-pulse rounded bg-surface" />
            <div className="mt-4 flex gap-2">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="h-10 w-24 animate-pulse rounded-full bg-surface" />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-7xl space-y-3 px-4 py-10 lg:px-8">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="h-12 w-full animate-pulse rounded-lg bg-surface" />
        ))}
      </div>
    </AppShell>
  );
}
